<style>
.srm-swatch-small {
  width: 16px !important;
  height: 16px !important;
  float: left;
  margin-right: 5px;
}

table.recipe {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  border-spacing: 0;
}

table.recipe th,
table.recipe td {
  text-align: left;
}

table.recipe > thead > tr > th {
  font-size: 14px;
  font-weight: 700;
  padding: 10px;
  color: #4a4a4a;
  background-color: rgba(0, 0, 0, 0.1);
  border-top: solid 1px #e6e6e6;
}

table.recipe > tbody > tr > td {
  border-top: solid 1px #e6e6e6;
  padding: 10px;
}

table.recipe th.collapsing,
table.recipe td.collapsing {
  width: 1px;
  white-space: nowrap;
}

@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  table.recipe th.collapsing,
  table.recipe td.collapsing {
    width: auto !important;
  }

  .ui.padded.segment.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    border-radius: 0px !important;
    border-left: none !important;
    border-right: none !important;
  }

  .ui.padded.segment.container .ui.container {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .ui.header {
    padding: 0 5px 0 5px;
  }

  .recipe tbody tr:nth-of-type(odd) {
    background: #eee;
  }

  /* Force table to not be like tables anymore */
  table.recipe,
  .recipe thead,
  .recipe tbody,
  .recipe thead th,
  .recipe thead th td,
  .recipe tbody tr,
  .recipe tbody tr td {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .recipe thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .recipe tbody tr {
    /*border: 1px solid #ccc !important;*/
    border-top: none !important;
  }

  .recipe tbody tr td {
    position: relative !important;
    padding-left: 25% !important;
    text-align: left !important;
  }

  .recipe tbody tr td:before {
    /* Now like a table header */
    position: absolute !important;
    /* Top/left values mimic padding */
    top: 11px !important;
    left: 6px !important;
    width: 25% !important;
    padding-right: 10px !important;
    white-space: nowrap !important;
    font-weight: bold;
    /*text-align: left;*/
  }

  /*Fermentables*/
  .recipe tbody.fermentable tr td:nth-of-type(1):before {
    content: 'Amount:';
  }

  .recipe tbody.fermentable tr td:nth-of-type(2):before {
    content: 'Name:';
  }

  .recipe tbody.fermentable tr td:nth-of-type(3):before {
    content: 'Yield:';
  }

  .recipe tbody.fermentable tr td:nth-of-type(4):before {
    content: 'Color:';
  }

  .recipe tbody.fermentable tr td:nth-of-type(5):before {
    content: 'Batch %:';
  }

  /*Hops*/
  .recipe tbody.hops tr td:nth-of-type(1):before {
    content: 'Amount';
  }

  .recipe tbody.hops tr td:nth-of-type(2):before {
    content: 'Name';
  }

  .recipe tbody.hops tr td:nth-of-type(3):before {
    content: 'Time';
  }

  .recipe tbody.hops tr td:nth-of-type(4):before {
    content: 'Use';
  }

  .recipe tbody.hops tr td:nth-of-type(5):before {
    content: 'Hop Form';
  }

  .recipe tbody.hops tr td:nth-of-type(6):before {
    content: 'Alpha';
  }

  /* Yeast */
  .recipe tbody.yeast tr td:nth-of-type(1):before {
    content: 'Name';
  }

  .recipe tbody.yeast tr td:nth-of-type(2):before {
    content: 'Form';
  }

  .recipe tbody.yeast tr td:nth-of-type(3):before {
    content: 'Type';
  }

  .recipe tbody.yeast tr td:nth-of-type(4):before {
    content: 'Attn';
  }

  /* Adjuncts */
  .recipe tbody.adjuncts tr td:nth-of-type(1):before {
    content: 'Amount';
  }

  .recipe tbody.adjuncts tr td:nth-of-type(2):before {
    content: 'Name';
  }

  .recipe tbody.adjuncts tr td:nth-of-type(3):before {
    content: 'Time';
  }

  .recipe tbody.adjuncts tr td:nth-of-type(4):before {
    content: 'Use';
  }

  .recipe tbody.adjuncts tr td:nth-of-type(5):before {
    content: 'Type';
  }

  /* Mash */
  .recipe tbody.mash tr td:nth-of-type(1):before {
    content: 'Name';
  }

  .recipe tbody.mash tr td:nth-of-type(2):before {
    content: 'Time';
  }

  .recipe tbody.mash tr td:nth-of-type(3):before {
    content: 'Temp';
  }

  .recipe tbody.mash tr td:nth-of-type(4):before {
    content: 'Type';
  }
}
</style>
<template>
    <div>
        <div class="ui divider"></div>

        <div class="ui grid">
            <div class="sixteen wide mobile sixteen wide tablet eight wide computer column">
                <h4 class="ui header">
                    Fermentables
                </h4>
                <table class="recipe">
                    <thead>
                        <tr>
                            <th class="align-left collapsing">Amount</th>
                            <th class="align-left">Name</th>
                            <th class="align-right collapsing">Yield</th>
                            <th class="align-right collapsing">Color (&deg;L)</th>
                            <th class="align-right collapsing">Batch %</th>
                        </tr>
                    </thead>
                    <tbody v-if="brew.recipe.fermentables == null || brew.recipe.fermentables.length == 0">
                        <tr>
                            <td colspan="4">No Fermentables listed in Recipe</td>
                        </tr>
                    </tbody>

                    <tbody v-else class="fermentable">
                        <tr v-for="fermentable in brew.recipe.fermentables">
                            <td class="align-right collapsing">
                                <kg-label :value="fermentable.amount" />
                            </td>
                            <td>
                                {{ fermentable.name }}
                                <srm-label :value="fermentable.color" />
                            </td>
                            <td class="align-right collapsing">
                                {{ fermentable.yield | percent}}
                            </td>
                            <td class="align-right collapsing">
                                {{ fermentable.color | float(1)}} &deg;L
                            </td>
                            <td class="align-right collapsing">
                                {{ fermentable.batchPercentage | percent}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="sixteen wide mobile sixteen wide tablet eight wide computer column">

                <h4 class="ui header">
                    Hops
                </h4>
                <table class="recipe">
                    <thead>
                        <tr>
                            <th class="align-left collapsing">Amount</th>
                            <th class="align-left">Hop Name</th>
                            <th class="align-left collapsing">Time</th>
                            <th class="align-left collapsing">Use</th>
                            <th class="align-left collapsing">Hop Form</th>
                            <th class="align-right collapsing">Alpha</th>
                        </tr>
                    </thead>
                    <tbody v-if="brew.recipe.hops == null || brew.recipe.hops.length == 0">
                        <tr>
                            <td colspan="6">No Hops listed in Recipe</td>
                        </tr>
                    </tbody>

                    <tbody class="hops" v-else>
                        <tr v-for="hop in brew.recipe.hops" v-once>
                            <td class="align-right">
                                <kg-label :value="hop.amount" />
                            </td>
                            <td class="align-left">{{ hop.name }}</td>
                            <td class="align-right collapsing">{{ hop.time | toMinsDays }}</td>
                            <td class="align-left collapsing">{{ hop.use }}</td>
                            <td class="align-left collapsing">{{ hop.form }}</td>
                            <td class="align-right">{{ hop.alpha | percent }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="sixteen wide mobile sixteen wide tablet eight wide computer column">

                <h4 class="ui header">
                    {{ brew.recipe.yeasts.length > 1 ? "Yeasts" : "Yeast" }}
                </h4>
                <table class="recipe">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th class="collapsing">Form</th>
                            <th class="collapsing">Type</th>
                            <th class="align-right collapsing">Attenuation</th>
                        </tr>
                    </thead>
                    <tbody v-if="brew.recipe.yeasts == null || brew.recipe.yeasts.length == 0">
                        <tr>
                            <td colspan="4">No yeast listed in Recipe</td>
                        </tr>
                    </tbody>
                    <tbody class="yeast" v-else>
                        <tr v-for="yeast in brew.recipe.yeasts">
                            <td class="align-left">
                                {{ yeast.name }}
                            </td>
                            <td class="collapsing">{{ yeast.form }}</td>
                            <td class="collapsing">{{ yeast.type }}</td>
                            <td class="align-right collapsing">{{ yeast.attenuation | percent }}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="sixteen wide mobile sixteen wide tablet eight wide computer column">

                <template v-if="brew.recipe.miscs != null && brew.recipe.miscs.length > 0">
                    <h4 class="ui header">
                        Additional Ingredients
                    </h4>
                    <table class="recipe">
                        <thead>
                            <tr>
                                <th class="collapsing">Amount</th>
                                <th>Name</th>
                                <th>Time</th>
                                <th class="collapsing">Use</th>
                                <th class="collapsing">Type</th>
                            </tr>
                        </thead>
                        <tbody class="adjuncts">
                            <tr v-for="misc in brew.recipe.miscs">
                                <td class="collapsing">
                                    <kg-label :value="misc.amount" v-if="misc.isWeight" />
                                    <liquid-label :value="misc.amount" v-else />
                                </td>
                                <td>{{ misc.name }}</td>
                                <td class="align-right  collapsing">{{ misc.time | toMinsDays}}</td>
                                <td class="collapsing">{{ misc.use }}</td>
                                <td class="collapsing">{{ misc.type }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
            <div class="sixteen wide mobile sixteen wide tablet eight wide computer column">

                <template v-if="brew.recipe.mash != null && brew.recipe.mash.mashSteps != null && brew.recipe.mash.mashSteps.length > 0">
                    <h4 class="ui header">
                        Mash Steps
                    </h4>
                    <table class="recipe">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th class="align-right collapsing">Time</th>
                                <th class="align-right collapsing">Temp</th>
                                <th class="align-right collapsing">Type</th>
                            </tr>
                        </thead>
                        <tbody class="mash">
                            <tr v-for="mashStep in brew.recipe.mash.mashSteps" v-once>
                                <td>{{ mashStep.name }}</td>
                                <td class="align-right collapsing">{{ mashStep.stepTime | toMinsDays}}</td>
                                <td class="align-right collapsing">
                                    <temp-label :value="mashStep.stepTemp" :originalIsCelcius="true" />
                                </td>
                                <td class="align-right collapsing">{{ mashStep.type }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>
    </div>
</template>
<script>

import _orderBy from 'lodash/orderBy';
import { mapState } from 'vuex';

export default {
  name: 'BrewRecipe',
  props: ['recipe'],
  computed: {
    ...mapState(['currentUser', 'brew']),
    fermentables() {
      return _orderBy(this.recipe.fermentables, ['amountValue'], ['desc']);
    },
    yeasts() {
      return this.recipe.yeasts;
    },
    hops() {
      return _orderBy(this.recipe.hops, ['usageTypeId', 'time'], ['asc', 'desc']);
    },
    miscs() {
      return _orderBy(this.recipe.miscs, ['usageTypeId', 'time'], ['asc', 'desc']);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/sections/brew/BrewRecipe.vue